import { useCallback, useEffect, useRef } from "react";

const useTimer = ({ start, ms = 1000 * 60 * 29, onTimeover = () => {} }) => {
  const timeRef = useRef(null);

  const runTimer = useCallback((msMemo) => {
    timeRef.current = setInterval(onTimeover, msMemo);
  }, [onTimeover]);

  const stopTimer = () => clearInterval(timeRef.current)
  
  const resetTimer = () => {
    stopTimer()
    runTimer()
  }
  
  useEffect(() => {
    if (start) {
      runTimer(ms)
    } else {
      stopTimer()
    }

    return () => stopTimer()
  }, [ms, start, runTimer]);

  return { runTimer, resetTimer, stopTimer };
};

export default useTimer;
